import { useState, useMemo } from "react";

type UseDialogProps<T> = {
  initialData?: T | null;
  initialOpen?: boolean;
  clearOnClose?: boolean;
};

const defaultOptions = { initialData: null, initialOpen: false };

export function useDialog<T = null>({
  initialData = null,
  initialOpen = false,
  clearOnClose = true
}: UseDialogProps<T> = defaultOptions) {
  const [state, setState] = useState<{ open: boolean; data: T | null }>({
    open: initialOpen,
    data: initialData
  });

  return useMemo(
    () => ({
      open: state.open,
      data: state.data,
      onClose: () => setState({ open: false, data: clearOnClose ? null : state.data }),
      onOpen: ((data: T) =>
        setState({ open: true, data: data ?? null })) as T extends null
        ? () => void
        : (data: T) => void
    }),
    [state]
  );
}
